angular.module('historyPractice.components',[])
.component('historyPractice',{
    templateUrl: 'ng/components/historyPractice/historyPractice.view.html',
    bindings:{
        model: '<'
    },
    controllerAs: 'historyPracticeCtrl',
    controller: HistoryPractice
})

function HistoryPractice (){
    var self = this;

    self.$onInit = function(){
        console.log(self.model);
    }
}